<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.61169 21.1233L7.94471 22.0662L7.61169 21.1233ZM2.85585 22.8029L3.18886 23.7459L2.85585 22.8029ZM3.09025 16.0834L3.99083 15.6487L3.09025 16.0834ZM3.14806 16.879L4.09558 17.1987L3.14806 16.879ZM3.99083 15.6487C2.31783 12.1827 2.86593 7.89905 5.6787 4.95447L4.23249 3.573C0.825151 7.14 0.166074 12.3257 2.18967 16.5181L3.99083 15.6487ZM5.6787 4.95447C9.3028 1.16055 15.3163 1.02288 19.1102 4.64698L20.4917 3.20077C15.899 -1.18629 8.61956 -1.01964 4.23249 3.573L5.6787 4.95447ZM19.1102 4.64698C22.9041 8.27108 23.0418 14.2846 19.4177 18.0785L20.8639 19.46C25.251 14.8673 25.0843 7.58784 20.4917 3.20077L19.1102 4.64698ZM19.4177 18.0785C16.5959 21.0325 12.3234 21.7714 8.77777 20.2393L7.98448 22.0753C12.2733 23.9284 17.4456 23.0384 20.8639 19.46L19.4177 18.0785ZM7.27868 20.1804L2.52284 21.86L3.18886 23.7459L7.94471 22.0662L7.27868 20.1804ZM2.52284 21.86L4.09558 17.1987L2.20054 16.5593L0.627801 21.2206L2.52284 21.86ZM8.77777 20.2393C8.32202 20.0424 7.78648 20.001 7.27868 20.1804L7.94471 22.0662C7.94214 22.0671 7.94333 22.066 7.95005 22.0664C7.95727 22.0667 7.96939 22.0688 7.98448 22.0753L8.77777 20.2393ZM2.52284 21.86L2.52284 21.86L0.627801 21.2206C0.0945852 22.801 1.61619 24.3013 3.18886 23.7459L2.52284 21.86ZM2.18967 16.5181C2.19711 16.5335 2.19966 16.5461 2.20025 16.5537C2.20079 16.5607 2.19964 16.562 2.20054 16.5593L4.09558 17.1987C4.2744 16.6687 4.21481 16.1128 3.99083 15.6487L2.18967 16.5181Z" />
    <path
      d="M9.61011 11.3051C9.61011 12.0258 9.02582 12.6101 8.30506 12.6101C7.58429 12.6101 7 12.0258 7 11.3051C7 10.5843 7.58429 10 8.30506 10C9.02582 10 9.61011 10.5843 9.61011 11.3051Z" />
    <path
      d="M13.7906 11.3051C13.7906 12.0258 13.2063 12.6101 12.4856 12.6101C11.7648 12.6101 11.1805 12.0258 11.1805 11.3051C11.1805 10.5843 11.7648 10 12.4856 10C13.2063 10 13.7906 10.5843 13.7906 11.3051Z" />
    <path
      d="M17.963 11.3051C17.963 12.0258 17.3787 12.6101 16.6579 12.6101C15.9372 12.6101 15.3529 12.0258 15.3529 11.3051C15.3529 10.5843 15.9372 10 16.6579 10C17.3787 10 17.963 10.5843 17.963 11.3051Z" />
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box',
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
  },
}
</script>
